import { useMemo } from 'react';

import type { Pagination } from 'Types/pagination';

export interface UseVehicleListPaginationProps {
	currentPage: number;
	hasNextPage: boolean;
}

const useVehicleListPagination = ({ currentPage, hasNextPage }: UseVehicleListPaginationProps): Pagination => {
	const pagination = useMemo(
		() => ({ hasMore: Boolean(hasNextPage), page: currentPage, touched: true }),
		[hasNextPage, currentPage],
	);

	return pagination;
};

export default useVehicleListPagination;
